module.exports = __webpack_public_path__ + "media/images/global/icons/venue-05ca41f51b1d66b6a9cb0a4d0054a585.svg";